module.exports = __webpack_public_path__ + "img/elektroplaner-sf-0810.a183e1d6.jpg";